<template>
  <div class="extra-invoice-line">
    <div class="extra-picture" :style="`background-image: url(${picture})`">
    </div>
    <div class="extra-details">
      <div class="line1">{{ name }}</div>
      <div class="price-container">
        <span v-for="(date, index) in extra.dates"
             :key="date+index"
             class="list-badge">
            <strong>{{date.count}}x </strong>
            {{date.date | moment('ddd DD MMM') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import extraPriceMixin from "../../../components/mixins/extra-price.mixin";
import moment from 'moment';

export default {
  name: "step4-extra",
  mixins: [extraPriceMixin],
  props: {
    extra: {
      type: Object,
      required: true
    }
  },
  methods: {
    moment,
  },
  computed: {
    picture () { return `${this.extra.extra.picture}?w=100&h=100&crop-to-fit`},
    name () { return this.extra.extra.text.name; },
    price () {
      return this.calcExtraPrice(this.extra.extra, this.extra.dates, true);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tunnel/step4-multi/step4-extra.vue